import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Phone } from "lucide-react";
import { api } from "@/lib/api";

const WD = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
const dayLabel = (date, today) => {
  const diff = Math.round((new Date(`${date}T00:00:00Z`) - new Date(`${today}T00:00:00Z`)) / 86400000);
  const [, m, d] = date.split("-");
  const wd = WD[new Date(`${date}T00:00:00Z`).getUTCDay()];
  return diff === 0 ? `Hoy ${d}/${m}` : diff === 1 ? `Mañana ${d}/${m}` : `${wd} ${d}/${m}`;
};

/** Fix BP (2026-11-03): cartel para supervisores y admin con quién está de guardia pasiva hoy y los
 * próximos 3 días (pedido: avisar con 3 días de anticipación). GET /api/passive-guards/upcoming. */
export function PassiveGuardsUpcoming({ linkTo }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/passive-guards/upcoming", { params: { days: 3 } }).then(({ data: d }) => setData(d)).catch(() => setData(null));
  }, []);
  if (!data || !data.items?.length) return null;
  return (
    <div className="card" style={{ padding: 14, marginBottom: 14, borderLeft: "4px solid #7c3aed" }} data-testid="passive-guards-upcoming">
      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: "#7c3aed", marginBottom: 8 }}>
        <ShieldCheck size={13} /> Guardias pasivas · próximos 3 días
      </div>
      {data.items.map((g) => (
        <div key={`${g.guard_id}-${g.date}`} style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap", fontSize: 12, padding: "5px 0", borderTop: "1px solid var(--invict-bone-3)" }} data-testid={`passive-upcoming-${g.guard_id}-${g.date}`}>
          <span><b>{dayLabel(g.date, data.today)}</b> · {g.user_name}{g.time_from ? ` · ${g.time_from}–${g.time_to || ""}` : ""}{g.priority ? ` · prioridad ${g.priority}` : ""}</span>
          {g.contact_phone && <a href={`tel:${g.contact_phone}`} style={{ display: "inline-flex", alignItems: "center", gap: 4, color: "#0A0A0A", fontWeight: 700 }}><Phone size={12} /> {g.contact_phone}</a>}
        </div>
      ))}
      {linkTo && <Link to={linkTo} style={{ display: "inline-block", marginTop: 6, fontSize: 11, fontWeight: 700, color: "#7c3aed" }}>Ver guardias pasivas</Link>}
    </div>
  );
}
